module.exports = __webpack_public_path__ + "static/media/feed-dog.2702aa5a.webp";